import { WhoisApiClient, WhoisNetworkError } from './whois.apiClient';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { ExperimentSpecs } from '../constants';
function getHttpStatus(err) {
  var _e$response;
  if (err == null || typeof err !== 'object') {
    return undefined;
  }
  const e = err;
  const status = e.httpStatus ?? e.status ?? ((_e$response = e.response) == null ? void 0 : _e$response.status);
  return typeof status === 'number' ? status : undefined;
}
function classifyError(err) {
  return {
    isNetworkError: err instanceof WhoisNetworkError || !navigator.onLine,
    status: getHttpStatus(err),
    message: err instanceof Error ? err.message : undefined
  };
}
export const useWhoisLookup = domain => {
  var _getPremiumEssentials;
  const progressiveOn = !!((_getPremiumEssentials = getPremiumEssentialsSafe()) != null && (_getPremiumEssentials = _getPremiumEssentials.experiments) != null && _getPremiumEssentials[ExperimentSpecs.WhoisProgressiveLookup]);
  const _WhoisApiClient$hooks = WhoisApiClient.hooks.useWhoisLookup({
      domain
    }, !!domain),
    data = _WhoisApiClient$hooks.data,
    isLoading = _WhoisApiClient$hooks.isLoading,
    error = _WhoisApiClient$hooks.error,
    refetch = _WhoisApiClient$hooks.refetch;

  // Raw WHOIS text loads independently and never blocks the card. It is only
  // needed for the RDAP path — the WHOIS-fallback card (ccTLDs) already carries
  // its raw text. Disabled entirely when the progressive lookup spec is off.
  const rawEnabled = progressiveOn && !!domain && (data == null ? void 0 : data.source) === 'RDAP';
  const _WhoisApiClient$hooks2 = WhoisApiClient.hooks.useWhoisRaw({
      domain
    }, rawEnabled),
    rawData = _WhoisApiClient$hooks2.data;
  const mergedData = data ? rawData ? {
    ...data,
    raw: rawData
  } : data : undefined;
  return {
    data: mergedData,
    isLoading,
    error: error != null ? classifyError(error) : undefined,
    retry: refetch
  };
};
//# sourceMappingURL=useWhoisLookup.js.map